import React from "react";
import "./Slider.css";

const SlidersModal = ({
  showModal,
  currentImage,
  closeModal,
  downloadZipFile,
  isDownloading,
}) => {
  if (!showModal || !currentImage) return null;

  return (
    <div className="fullscreen-modal-overlay">
      <div className="fullscreen-modal">
        <button
          className="fullscreen-modal-close"
          onClick={closeModal}
          aria-label="Cerrar modal"
        >
          <i className="bi bi-x"></i>
        </button>

        {currentImage.modaltext && currentImage.title && (
          <div className="titulo-modal">{currentImage.title}</div>
        )}

        <div className="fullscreen-modal-body">
          {currentImage.modaltext && (
            <ul className="modal-text-list">
              {currentImage.textContent?.map((item, index) => (
                <li key={index}>
                  {item.url ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="list-link"
                    >
                      {item.text}
                    </a>
                  ) : (
                    <span>{item.text}</span>
                  )}
                </li>
              ))}
            </ul>
          )}

          {(currentImage.modalimage || currentImage.modalzip) && (
            <div className="modal-image-container">
              <img
                src={currentImage.modalImageUrl || (currentImage.imgUrl?.startsWith("http") ? currentImage.imgUrl : `https://itetlax.org.mx/assets/img/imgC_I/${currentImage.imgUrl}`)}
                className="modal-image"
                alt={currentImage.alt}
              />
            </div>
          )}
        </div>

        <div className="fullscreen-modal-footer">
          {currentImage.modalDownloadActive && currentImage.modalDownloadUrl && (
            <button
              className="modal-btn"
              onClick={() => {
                const link = document.createElement("a");
                link.href = currentImage.modalDownloadUrl;
                link.download =
                  currentImage.modalDownloadUrl.split("/").pop() || "descarga";
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <i className="bi bi-download"></i> DESCARGAR
            </button>
          )}

          {(currentImage.modalimage || currentImage.modalzip) &&
            currentImage.url && (
              <button
                className="modal-btn"
                onClick={() => window.open(currentImage.url, "_blank")}
              >
                <i className="bi bi-eye-fill"></i> VISUALIZAR EN LÍNEA
              </button>
            )}

          {currentImage.modalzip && currentImage.zipFile && (
            <button
              className="modal-btn"
              onClick={downloadZipFile}
              disabled={isDownloading}
            >
              {isDownloading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1"></span>
                  DESCARGANDO
                </>
              ) : (
                <>
                  <i className="bi bi-file-earmark-zip-fill"></i> DESCARGAR
                  ANEXOS (ZIP)
                </>
              )}
            </button>
          )}

          {currentImage.registerUrl && (
            <button
              className="modal-btn register-btn"
              onClick={() => window.open(currentImage.registerUrl, "_blank")}
            >
              <i className="bi bi-person-plus-fill"></i> REGISTRATE
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SlidersModal;
